import { useEffect } from 'react'
import { EventNames } from '../../types/misc.types'
import { trackEvent } from '../../utils/appBridge'
import BottomSheetContent from './BottomSheetContent'
import { HelpDialogPassage } from './HelpDialogPassage'

type BottomSheetWrapperPropTypes = {
  onDismiss: () => void
  ScreenName: string
}

const TITLE_CLASS = 'text-[#232323] text-sm font-medium leading-tight'
const BODY_CLASS = 'text-[#6a6e6e] text-sm font-normal leading-[21px]'

const PASSAGES = [
  {
    title: 'P/E Ratio',
    body: "P/E or Price-to-Earnings (P/E) Ratio shows how much you're paying to generate 1 rupee of earning from the mutual fund. The lower it is, the better."
  },
  {
    title: 'P/B Ratio',
    body: "P/B or price-to-book ratio is the average P/B ratio of all stocks a fund holds. (A stock's book value is the difference between total assets and liabilities.) P/B ratio is calculated by dividing a company's market price by its book value. The lower it is, the better"
  },
  {
    title: 'Alpha Ratio',
    body: 'Alpha ratio measures the percent of excess returns that the fund generated over its benchmark. An alpha ratio of 2.5 means that the fund generated 2.5% higher returns over its benchmark.'
  },
  {
    title: 'Beta Ratio',
    body: "Beta ratio measures the fund's volatility, relative to its benchmark index. A beta less than 1 means the fund is less volatile than its benchmark and vice versa."
  },
  {
    title: 'Sharpe Ratio',
    body: "Sharpe ratio measures a fund's risk-adjusted returns, considering overall volatility. A higher ratio means that it gives better returns for the overall risk taken."
  },
  {
    title: 'Sortino Ratio',
    body: "Sortino ratio measures a fund's risk-adjusted returns considering downside volatility. A higher ratio means that it gives better returns for the risk of loss taken."
  }
] as const

export const AdvancedRatios = ({ onDismiss, ScreenName }: BottomSheetWrapperPropTypes) => {
  const heading = 'Advanced Ratios'
  useEffect(() => {
    trackEvent({
      eventName: EventNames.KnowMoreBottomSheetLoad,
      payload: {
        eventId: heading,
        ScreenName
      }
    })
  }, [])
  return (
    <BottomSheetContent heading={heading} onDismiss={onDismiss}>
      <div className='flex flex-col gap-4'>
        {PASSAGES.map((passage) => (
          <HelpDialogPassage
            key={passage.title}
            accessibleLabel={`${passage.title}. ${passage.body}`}
          >
            <span className={TITLE_CLASS}>{passage.title}</span>
            <br />
            <span className={BODY_CLASS}>{passage.body}</span>
          </HelpDialogPassage>
        ))}
      </div>
    </BottomSheetContent>
  )
}
